import { BannerTitlePropTypes } from '@/components/BannerTitle/BannerTitle.types';
import { Banner } from './BannerSection.styles';

export function BannerSection(props: BannerTitlePropTypes): JSX.Element {
  return <Banner {...props} />;
}
